import {
  ArrowDownLeftIcon,
  ArrowRightIcon,
  ArrowUpRightIcon,
} from 'lucide-react'

import { cn } from 'utils'

interface YoYChangeIndicatorProps {
  change: number;
  displayValue?: string;
  increaseIsGreen: boolean;
  makeInvisible: boolean;
  size?: 'normal' | 'small';
}

const YoYChangeIndicator = ({
  change,
  displayValue,
  increaseIsGreen,
  makeInvisible,
  size = 'normal',
}: YoYChangeIndicatorProps) => {
  return (
    <div
      className={cn('flex flex-row gap-1 items-center', {
        invisible: makeInvisible,
      })}
    >
      {change > 0 && (
        <ArrowUpRightIcon
          className={cn('h-3 w-3', {
            'text-green-400': increaseIsGreen,
            'text-red-500': !increaseIsGreen,
          })}
        />
      )}
      {change < 0 && (
        <ArrowDownLeftIcon
          className={cn('h-3 w-3', {
            'text-green-400': !increaseIsGreen,
            'text-red-500': increaseIsGreen,
          })}
        />
      )}
      {change === 0 && <ArrowRightIcon className='h-3 w-3 text-gray-400' />}
      <span
        data-testid='percentage-indicator'
        className={cn({
          'body-sm-bold': size === 'normal',
          caption: size === 'small',
          'text-green-400':
            (increaseIsGreen && change > 0) ||
            (!increaseIsGreen && change < 0),
          'text-red-500':
            (increaseIsGreen && change < 0) ||
            (!increaseIsGreen && change > 0),
          'text-gray-400': change === 0,
        })}
      >
        {!displayValue && change === 0 && 'No change'}
        {displayValue}
      </span>
    </div>
  )
}

export default YoYChangeIndicator
